'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContentTooltip = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactackleAutoposition = require('reactackle-autoposition');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var wrapWithClass = function wrapWithClass(Component) {
  var isFunctionalComponent = function isFunctionalComponent(Component) {
    return !Component.prototype.render;
  };
  if (!isFunctionalComponent(Component)) return Component;
  // eslint-disable-next-line react/prefer-stateless-function
  return function (_React$Component) {
    _inherits(ClassComponent, _React$Component);

    function ClassComponent() {
      _classCallCheck(this, ClassComponent);

      return _possibleConstructorReturn(this, (ClassComponent.__proto__ || Object.getPrototypeOf(ClassComponent)).apply(this, arguments));
    }

    _createClass(ClassComponent, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }]);

    return ClassComponent;
  }(_react2.default.Component);
};

var withContentTooltip = exports.withContentTooltip = function withContentTooltip(Component, TooltipContent) {
  var propTypes = {
    closeOnOutsideClick: _propTypes2.default.bool
  };
  var defaultProps = {
    closeOnOutsideClick: true
  };
  // eslint-disable-next-line react/no-multi-comp

  var WithTooltip = function (_React$Component2) {
    _inherits(WithTooltip, _React$Component2);

    function WithTooltip(props) {
      _classCallCheck(this, WithTooltip);

      var _this2 = _possibleConstructorReturn(this, (WithTooltip.__proto__ || Object.getPrototypeOf(WithTooltip)).call(this, props));

      _this2.state = {
        targetRef: null,
        contentRef: null,
        visible: false
      };

      _this2.TooltipTarget = wrapWithClass(Component);
      _this2.TooltipContent = wrapWithClass(TooltipContent);

      _this2._handleContentRef = _this2._handleContentRef.bind(_this2);
      _this2._handleTargetRef = _this2._handleTargetRef.bind(_this2);
      _this2._toggleTooltip = _this2._toggleTooltip.bind(_this2);
      _this2._openTooltip = _this2._openTooltip.bind(_this2);
      _this2._closeTooltip = _this2._closeTooltip.bind(_this2);
      _this2._handleOutsideClick = _this2._handleOutsideClick.bind(_this2);
      _this2._applyOutsideListener = _this2._applyOutsideListener.bind(_this2);
      return _this2;
    }

    _createClass(WithTooltip, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this._handleOutsideClick);
      }
    }, {
      key: '_handleTargetRef',
      value: function _handleTargetRef(ref) {
        // eslint-disable-next-line
        this.setState({ targetRef: _reactDom2.default.findDOMNode(ref) });
      }
    }, {
      key: '_handleContentRef',
      value: function _handleContentRef(ref) {
        // eslint-disable-next-line
        this.setState({ contentRef: _reactDom2.default.findDOMNode(ref) });
      }
    }, {
      key: '_toggleTooltip',
      value: function _toggleTooltip() {
        this.setState(function (_ref) {
          var visible = _ref.visible;
          return {
            visible: !visible
          };
        }, this._applyOutsideListener);
      }
    }, {
      key: '_openTooltip',
      value: function _openTooltip() {
        this.setState({ visible: true }, this._applyOutsideListener);
      }
    }, {
      key: '_closeTooltip',
      value: function _closeTooltip() {
        this.setState({ visible: false }, this._applyOutsideListener);
      }
    }, {
      key: '_applyOutsideListener',
      value: function _applyOutsideListener() {
        if (!this.props.closeOnOutsideClick) return;

        if (this.state.visible) {
          document.addEventListener('click', this._handleOutsideClick);
        } else {
          document.removeEventListener('click', this._handleOutsideClick);
        }
      }
    }, {
      key: '_handleOutsideClick',
      value: function _handleOutsideClick(e) {
        if (!this.state.contentRef.contains(e.target)) {
          this._closeTooltip();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var TooltipTarget = this.TooltipTarget,
            TooltipContent = this.TooltipContent;


        var tooltipProps = {
          openTooltip: this._openTooltip,
          closeTooltip: this._closeTooltip,
          toggleTooltip: this._toggleTooltip
        };

        var renderAutoPosition = !this.state.targetRef && !this.state.visible ? null : _react2.default.createElement(
          _reactackleAutoposition.AutoPosition,
          {
            parent: this.state.targetRef,
            type: 'outer',
            visible: this.state.visible
          },
          _react2.default.createElement(TooltipContent, _extends({}, this.props, tooltipProps, {
            ref: this._handleContentRef
          }))
        );

        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(TooltipTarget, _extends({}, this.props, tooltipProps, {
            ref: this._handleTargetRef
          })),
          renderAutoPosition
        );
      }
    }]);

    return WithTooltip;
  }(_react2.default.Component);

  WithTooltip.propTypes = propTypes;
  WithTooltip.defaultProps = defaultProps;
  WithTooltip.displayName = 'withContentTooltip(' + Component.displayName + ')';

  return WithTooltip;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip/dist/withContentTooltip.js
// module id = 884
// module chunks = 0